
      <div class="grid">      
    <div class="col-12 xl:col-6">
        <div class="card mb-0" >
            <h6>Revenue trend <i *ngIf="isDailySummaryLoading"
                    class="pi pi-spin pi-spinner"></i></h6>
           
            <p-chart *ngIf="!isDailySummaryLoading" [ngStyle]="{width: '10rem'}" [data]="revenue_chartData" [options]="revenue_chartOptions"
                type="bar" responsive="true">
            </p-chart>
        </div>
    </div>
    <div class="col-12 xl:col-6">
        <div class="card mb-0">
            <h6>Profit trend <i *ngIf="isDailySummaryLoading"
                    class="pi pi-spin pi-spinner"></i></h6>
            <p-chart *ngIf="!isDailySummaryLoading" [ngStyle]="{width: '10rem'}" [data]="profit_chartData" [options]="revenue_chartOptions"
                type="bar" responsive="true">
            </p-chart>
        </div>
    </div>
    </div>
    
   
